import { Links, LinksVariant } from "@att-bit/duc.components.links";
import { TooltipInterface } from "@att-bit/duc.components.tooltip";
import React from "react";
// import { IThemePanelContext } from '../../components/theme-provider';

export interface HeadingProps {
  /**  to allow Heading to process text for HTML elements */
  allowDangerousHtml?: boolean;
  /**  heading content */
  children?: any;
  /**  heading html tag */
  headingTag?: HeadingTags;
  /**  eyebrow content */
  eyebrow?: string;
  /** tooltip data */
  tooltipData?: any;
  /**  heading color class */
  headingColor?: string;
  /**  eyebrow color class */
  eyebrowColor?: string;
  /**  size of heading */
  size?: HeadingSizes;
  /**  spacing classes */
  margin?: string[];
  /** Heading link url */
  headingLinkUrl?: string;
  /**Provision of adding additional classes for heading link as url */
  headingLinkUrlClasses?: string;
}

export enum HeadingSizes {
  XXXL = "heading-xxxl",
  XXL = "heading-xxl",
  XL = "heading-xl",
  LG = "heading-lg",
  MD = "heading-md",
  SM = "heading-sm",
  XS = "heading-xs",
}

export enum HeadingTags {
  H1 = "h1",
  H2 = "h2",
  H3 = "h3",
  H4 = "h4",
  H5 = "h5",
  H6 = "h6",
  P = "p",
}

export const Heading = ({
  allowDangerousHtml = false,
  children,
  headingTag = HeadingTags.H2,
  eyebrow,
  size,
  eyebrowColor,
  headingColor,
  margin = ["mar-b-xs"],
  headingLinkUrl,
  headingLinkUrlClasses,
  tooltipData
}: HeadingProps & React.HTMLAttributes<HTMLElement>) => {
  let headingSize = size ? size : HeadingSizes.XXL;
  const doEyebrow: boolean =
    eyebrow &&
    headingSize !== HeadingSizes.SM &&
    headingSize !== HeadingSizes.XS &&
    true;
  const eyebrowClasses: string[] = [];
  const headingClasses: string[] = [...margin];
  const HeadingTag = headingTag;
  headingClasses.push(headingSize);
  if(tooltipData) {
    headingClasses.push("inline-block", "mar-r-xxs", "valign-middle");
  }
  let tooltipObj;
  if(tooltipData) {
    tooltipObj = TooltipInterface.initWithSanity("tooltip", tooltipData);
  }
  if (doEyebrow) {
    eyebrowClasses.push(headingSize.replace("heading", "type-eyebrow"));
    eyebrowColor ? eyebrowClasses.push(eyebrowColor) : "";
  }
  let headingLinkClasses;
  if (headingLinkUrlClasses) {
    headingLinkClasses = headingLinkUrlClasses;
  }
  headingColor ? headingClasses.push(headingColor) : "";
  let specialCharactersPresent = false;

  if (
    children &&
    typeof children === "string" &&
    (children.includes("<sup>") || children.includes("<sub>"))
  ) {
    specialCharactersPresent = true;
  }

  if (headingLinkUrl) {
    specialCharactersPresent = true;
  }

  if (
    (allowDangerousHtml || specialCharactersPresent) &&
    (eyebrow || children)
  ) {
    return (
      <>
        {doEyebrow && (
          <p
            className={eyebrowClasses.join(" ")}
            dangerouslySetInnerHTML={{ __html: eyebrow }}
          ></p>
        )}
        {headingLinkUrl && headingLinkUrl !== "" ? (
          <HeadingTag className={headingClasses.join(" ")}>
            <Links
              variant={LinksVariant.textUnderline}
              href={headingLinkUrl}
              isNewTab={true}
              dangerouslySetInnerHTML={{ __html: children }}
              className={headingLinkClasses}
            ></Links>
          </HeadingTag>
        ) : (
          <HeadingTag
            className={headingClasses.join(" ")}
            dangerouslySetInnerHTML={{ __html: children }}
          />
        )}
         {tooltipData && tooltipObj.toJsx()}
      </>
    );
  } else {
    return (
      <>
        {doEyebrow && <div className={eyebrowClasses.join(" ")}>{eyebrow}</div>}
        {children && (
          <HeadingTag className={headingClasses.join(" ")}>
            {children}
          </HeadingTag>
        )}
        {tooltipData && tooltipObj.toJsx()}
      </>
    );
  }
};

export default Heading;
